import * as MyFilters from "./filters.js";

/**
 * IterateAndMergeAllThePlacesAndPointsInto1DArray - Iterate all the places with points and create 1D array
 * @param {data} data - Places and Points multidimension Array
 * @return {locations} locations 1D array of all the points
 **/
export function IterateAndMergeAllThePlacesAndPointsInto1DArray(data) {
  let pointIndex = 0;
  let locations = [];

  for (const place of data.places) {
    for (const object of place.points) {
      if (object.objectName.toLowerCase().includes("test")) continue;

      locations.push({
        icons: null,
        pointIndex: pointIndex++,
        stationId: object.stationId,
        unitId: object.unitId,
        projectName: object.projectName,
        objectName: object.objectName,
        name: object.name,
        sn: object.sn,
        plugType: object.plugType,
        powerType: object.powerType,
        nominalPower: object.nominalPower,
        type: object.type,
        latLng: [...object.latLng],
      });
    }
  }

  return locations;
}

/**
 * IteratePointsAndSetIcons - Iterate all the points and set icon URL based on unitType, powerType, stateDesc to given array of points
 * @param {points} points - 1D Array of points
 **/
export function IteratePointsAndSetIcons(points) {
  for (let i = 0; i < points.length; i++) {
    let stateDesc = points[i].stateDesc;

    if (points[i].type == MyFilters.type[1]) {
      // EESS
      if (stateDesc == "On") {
        points[i].icons = "/icons_products/icon_battery_green.svg";
      } else if (stateDesc == "Error") {
        points[i].icons = "/icons_products/icon_battery_red.svg";
      } else if (stateDesc == "CommError") {
        points[i].icons = "/icons_products/icon_battery_grey.svg";
      } else {
        points[i].icons = "/icons_products/icon_battery_grey.svg";
      }
    } else if (points[i].type == MyFilters.type[0]) {
      // EVC

      if (points[i].powerType == MyFilters.powerType[0]) {
        // AC
        if (stateDesc == "Ready" || stateDesc == "Ready-2") {
          points[i].icons = "/icons_products/icon_charger_slow_green.svg";
        } else if (stateDesc == "InUse" || stateDesc == "Connected" || stateDesc == "Charging" || stateDesc == "ChargingWithVentilation" || stateDesc == "Connected-2" || stateDesc == "Charging-2" || stateDesc == "ChargingWithVentilation-2") {
          points[i].icons = "/icons_products/icon_charger_slow_blue.svg";
        } else if (stateDesc == "CommError" || stateDesc == "Error" || stateDesc == "Fault") {
          points[i].icons = "/icons_products/icon_charger_slow_red.svg";
        } else {
          points[i].icons = "/icons_products/icon_charger_slow_grey.svg";
        }
      } else if (points[i].powerType == MyFilters.powerType[1]) {
        // DC
        if (stateDesc == "Ready" || stateDesc == "Ready-2") {
          points[i].icons = "/icons_products/icon_charger_fast_green.svg";
        } else if (stateDesc == "InUse" || stateDesc == "Connected" || stateDesc == "Charging" || stateDesc == "ChargingWithVentilation" || stateDesc == "Connected-2" || stateDesc == "Charging-2" || stateDesc == "ChargingWithVentilation-2") {
          points[i].icons = "/icons_products/icon_charger_fast_blue.svg";
        } else if (stateDesc == "CommError" || stateDesc == "Error" || stateDesc == "Fault") {
          points[i].icons = "/icons_products/icon_charger_fast_red.svg";
        } else {
          points[i].icons = "/icons_products/icon_charger_fast_grey.svg";
        }
      }
    } else {
      points[i].icons = "/icons_products/icon_battery_grey.svg";
    }
  }
}
